import {AxiosError} from 'axios'
import {NavigateFunction} from 'react-router'

const ERROR_403 = '/error403'
const ERROR_500 = '/error500'

export const handleTasksError = (err: AxiosError, navigate: NavigateFunction): void => {
  const errorCode = err.response?.status
  if (errorCode === 403) {
    void navigate(ERROR_403)
  }
  if (errorCode && errorCode >= 500) {
    void navigate(ERROR_500, {state: JSON.stringify(err)})
  }
}
